/**
 * Created by zhongzhengkai on 2016/11/8.
 */

import 'whatwg-fetch'

function parseJSON(response, reqSpec) {
  if (reqSpec.json === false)return response.text();
  else return response.json();
}


//method - 使用的HTTP动词， GET , POST , PUT , DELETE , HEAD
//url - 请求地址，URL of the request
//headers - 关联的Header对象
//referrer - referrer
//mode - 请求的模式，主要用于跨域设置， cors , no-cors , same-origin
//credentials - 是否发送Cookie omit , same-origin
//redirect - 收到重定向请求之后的操作， follow , error , manual
//integrity - 完整性校验
//cache - 缓存模式( default , reload , no-cache )

/**
 *
 * @param path
 * @param options {object}
 * @param reqSpec {object}
 * @param options.method {string}
 * @param options.body {object} 当method为POST时,要提交的数据
 * @param cb
 * @returns {*}
 */
export function doRequest(path, options, reqSpec, cb) {
  options.body = JSON.stringify(options.body);
  fetch(path, options)
    .then((response)=> parseJSON(response,reqSpec))
    .then(function (reply) {
      cb(null, reply);
    })
    .catch(function (error) {
      if(error instanceof Error){
        if (error.message.indexOf('Unexpected end') >=0
          || error.message.indexOf('The string did not match the expected pattern') >= 0
          || error.message.indexOf('Unexpected EOF') >= 0
          || error.message.indexOf('Unexpected token') >= 0
          || error.message.indexOf('JSON Parse error') >= 0
        ) {
          if (!reqSpec.hasReply)cb(null, '');
          else {
            console.log('%c' + error.message, 'color:red');
            error.message = '服务器端返回空对象';
            cb(error, null);
          }
        } else if (error.message && error.message.indexOf('Type error') != -1) {//!!! ios里设置不允许使用无线网络权限时，会报此错误
          cb('应用程序没有使用无线网络的权限，请去设置里重新授权', null);
        } else if (error.message && error.message.indexOf('Network request failed') != -1) {//!!! ios里设置不允许使用无线网络权限时，会报此错误
          cb('网络请求失败，请确保你的手机已正确接入网络', null);
        } else cb(error, null);
      }else{
        cb(error, null);
      }
    });
}



// WEBPACK FOOTER //
// ./src/base/tool/net.js